import React                 from 'react';
import PropTypes             from 'prop-types';
import { useTranslation }    from 'react-i18next';
import Modal                 from '@material-ui/core/Modal';
import Delete                from '@material-ui/icons/Delete';
import { Typography }        from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button                from '~/components/Button';
import Paper                 from '~/components/Paper';
import useStyles             from './styles';

/* eslint-disable no-unused-vars */
function DeleteAddon(props){
  /* eslint-enable no-unused-vars */
  const { deleteAction, name, modal, onClose, isLoading, id, message, textDelete, iconColor='error', buttonColor='error', icon=Delete } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return(
    <Modal
      open={modal}
      onClose={onClose}
    >
      <div className={classes.root} >
        <Paper
          classes={{
            root: classes.paper
          }}
          Icon={icon}
          iconColor={iconColor}
          title={t('delete-modal-title', {addonName: name })}
          >
          <Typography align='center' variant='subtitle1' >
            { message ? message : `${t('delete-modal-text')} ${name || ''}?` }
          </Typography>
          <div className={classes.rootButtons} style={{textAlign: 'center'}}>
            {/* <div className={classes.wrapper}> */}
              <Button variant='contained' color='grey' onClick={onClose} className={classes.button}>
                {t('delete-modal-cancel')}
              </Button>
            {/* </div> */}
            {/* <div className={classes.wrapper}> */}
              <Button variant="contained" disabled={!!isLoading} color={buttonColor} onClick={() => deleteAction(id) } className={classes.button}>
                { textDelete || t('delete-modal-delete')}
              </Button>
              { isLoading && <CircularProgress size={24} className={classes.buttonProgress} /> }
            {/* </div> */}
          </div>
        </Paper>
      </div>
    </Modal>
  );
}

DeleteAddon.propTypes={
  deleteAction: PropTypes.func.isRequired,
  message: PropTypes.string,
  name: PropTypes.string,
  modal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  id: PropTypes.any,
  textDelete: PropTypes.string
};
export default DeleteAddon;
